/**
 * #817 — the Prev/Next sequence for ItemDetail.
 *
 * The order is the TREE'S VISIBLE ORDER WITH ACTIVE FILTERS, per the approved mockup —
 * not creation order, not a sibling list. RequirementsTree already computes exactly that
 * as `treeRows` (its flattened, filter-applied, expansion-aware row list); this derives
 * the two neighbours from it.
 *
 * Kept as a pure function, separate from both components, so the rule "what comes next"
 * can be tested without rendering a tree or an overlay. The tree publishes the order; the
 * view holds it; ItemDetail only renders what it is given.
 */

/**
 * @param {string[]} order  visible item ids, in the tree's own rendered order
 * @param {string}   currentId
 * @returns {{prevId: string|null, nextId: string|null, index: number, total: number}}
 *
 * An id that is not in the order (filtered out, collapsed away, or opened by deep link
 * before the tree has loaded) yields BOTH neighbours null rather than guessing a
 * position. Guessing would move the user somewhere unrelated to what they can see, and
 * a disabled pair is honest about the tree not containing the open item.
 */
export function itemNeighbours(order, currentId) {
  const list = Array.isArray(order) ? order : [];
  const index = currentId ? list.indexOf(currentId) : -1;
  if (index < 0) return { prevId: null, nextId: null, index: -1, total: list.length };
  return {
    prevId: index > 0 ? list[index - 1] : null,
    nextId: index < list.length - 1 ? list[index + 1] : null,
    index,
    total: list.length,
  };
}

export default itemNeighbours;
